module.exports = __webpack_public_path__ + "img/w43.39f846e3.svg";